import {createStrokeSVG} from './TEMPLATE'

// lucide: minimize-2
export const ArrowsDiagonalIn_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: ['m14 10 7-7', 'M20 10h-6V4', 'm3 21 7-7', 'M4 14h6v6'],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})

// lucide: maximize-2
export const ArrowsDiagonalOut_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: ['M15 3h6v6', 'm21 3-7 7', 'm3 21 7-7', 'M9 21H3v-6'],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
